var map = {
	"./001.png": 289,
	"./150.png": 290,
	"./419.png": 291,
	"./AD.png": 292,
	"./AE.png": 293,
	"./AF.png": 294,
	"./AG.png": 295,
	"./AI.png": 296,
	"./AL.png": 297,
	"./AM.png": 298,
	"./AN.png": 299,
	"./AO.png": 300,
	"./AR.png": 301,
	"./AS.png": 302,
	"./AT.png": 303,
	"./AU.png": 304,
	"./AW.png": 305,
	"./AX.png": 306,
	"./AZ.png": 307,
	"./BA.png": 308,
	"./BB.png": 309,
	"./BD.png": 310,
	"./BE.png": 311,
	"./BF.png": 312,
	"./BG.png": 313,
	"./BH.png": 314,
	"./BI.png": 315,
	"./BJ.png": 316,
	"./BL.png": 317,
	"./BM.png": 318,
	"./BN.png": 319,
	"./BO.png": 320,
	"./BQ.png": 321,
	"./BR.png": 322,
	"./BS.png": 323,
	"./BT.png": 324,
	"./BV.png": 325,
	"./BW.png": 326,
	"./BY.png": 327,
	"./BZ.png": 328,
	"./CA.png": 329,
	"./CC.png": 330,
	"./CD.png": 331,
	"./CF.png": 332,
	"./CG.png": 333,
	"./CH.png": 334,
	"./CI.png": 335,
	"./CK.png": 336,
	"./CL.png": 337,
	"./CM.png": 338,
	"./CN.png": 339,
	"./CO.png": 340,
	"./CR.png": 341,
	"./CS.png": 342,
	"./CU.png": 343,
	"./CV.png": 344,
	"./CW.png": 345,
	"./CX.png": 346,
	"./CY.png": 347,
	"./CZ.png": 348,
	"./DE.png": 349,
	"./DG.png": 350,
	"./DJ.png": 351,
	"./DK.png": 352,
	"./DM.png": 353,
	"./DO.png": 354,
	"./DZ.png": 355,
	"./EA.png": 356,
	"./EC.png": 357,
	"./EE.png": 358,
	"./EG.png": 359,
	"./EH.png": 360,
	"./ER.png": 361,
	"./ES.png": 362,
	"./ET.png": 363,
	"./FI.png": 364,
	"./FJ.png": 365,
	"./FK.png": 366,
	"./FM.png": 367,
	"./FO.png": 368,
	"./FR.png": 369,
	"./GA.png": 370,
	"./GB.png": 371,
	"./GD.png": 372,
	"./GE.png": 373,
	"./GF.png": 374,
	"./GG.png": 375,
	"./GH.png": 376,
	"./GI.png": 377,
	"./GL.png": 378,
	"./GM.png": 379,
	"./GN.png": 380,
	"./GP.png": 381,
	"./GQ.png": 382,
	"./GR.png": 383,
	"./GS.png": 384,
	"./GT.png": 385,
	"./GU.png": 386,
	"./GW.png": 387,
	"./GY.png": 388,
	"./HK.png": 389,
	"./HM.png": 390,
	"./HN.png": 391,
	"./HR.png": 392,
	"./HT.png": 393,
	"./HU.png": 394,
	"./IC.png": 395,
	"./ID.png": 396,
	"./IE.png": 397,
	"./IL.png": 398,
	"./IM.png": 399,
	"./IN.png": 400,
	"./IO.png": 401,
	"./IQ.png": 402,
	"./IR.png": 403,
	"./IS.png": 404,
	"./IT.png": 405,
	"./JE.png": 406,
	"./JM.png": 407,
	"./JO.png": 408,
	"./JP.png": 409,
	"./KE.png": 410,
	"./KG.png": 411,
	"./KH.png": 412,
	"./KI.png": 413,
	"./KM.png": 414,
	"./KN.png": 415,
	"./KP.png": 416,
	"./KR.png": 417,
	"./KW.png": 418,
	"./KY.png": 419,
	"./KZ.png": 420,
	"./LA.png": 421,
	"./LB.png": 422,
	"./LC.png": 423,
	"./LI.png": 424,
	"./LK.png": 425,
	"./LR.png": 426,
	"./LS.png": 427,
	"./LT.png": 428,
	"./LU.png": 429,
	"./LV.png": 430,
	"./LY.png": 431,
	"./MA.png": 432,
	"./MC.png": 433,
	"./MD.png": 434,
	"./ME.png": 435,
	"./MF.png": 436,
	"./MG.png": 437,
	"./MH.png": 438,
	"./MK.png": 439,
	"./ML.png": 440,
	"./MM.png": 441,
	"./MN.png": 442,
	"./MO.png": 443,
	"./MP.png": 444,
	"./MQ.png": 445,
	"./MR.png": 446,
	"./MS.png": 447,
	"./MT.png": 448,
	"./MU.png": 449,
	"./MV.png": 450,
	"./MW.png": 451,
	"./MX.png": 452,
	"./MY.png": 453,
	"./MZ.png": 454,
	"./NA.png": 455,
	"./NC.png": 456,
	"./NE.png": 457,
	"./NF.png": 458,
	"./NG.png": 459,
	"./NI.png": 460,
	"./NL.png": 461,
	"./NO.png": 462,
	"./NP.png": 463,
	"./NR.png": 464,
	"./NU.png": 465,
	"./NZ.png": 466,
	"./OM.png": 467,
	"./PA.png": 468,
	"./PE.png": 469,
	"./PF.png": 470,
	"./PG.png": 471,
	"./PH.png": 472,
	"./PK.png": 473,
	"./PL.png": 474,
	"./PM.png": 475,
	"./PN.png": 476,
	"./PR.png": 477,
	"./PS.png": 478,
	"./PT.png": 479,
	"./PW.png": 480,
	"./PY.png": 481,
	"./QA.png": 482,
	"./RE.png": 483,
	"./RO.png": 484,
	"./RS.png": 485,
	"./RU.png": 486,
	"./RW.png": 487,
	"./SA.png": 488,
	"./SB.png": 489,
	"./SC.png": 490,
	"./SD.png": 491,
	"./SE.png": 492,
	"./SG.png": 493,
	"./SH.png": 494,
	"./SI.png": 495,
	"./SJ.png": 496,
	"./SK.png": 497,
	"./SL.png": 498,
	"./SM.png": 499,
	"./SN.png": 500,
	"./SO.png": 501,
	"./SR.png": 502,
	"./SS.png": 503,
	"./ST.png": 504,
	"./SV.png": 505,
	"./SX.png": 506,
	"./SY.png": 507,
	"./SZ.png": 508,
	"./TC.png": 509,
	"./TD.png": 510,
	"./TF.png": 511,
	"./TG.png": 512,
	"./TH.png": 513,
	"./TJ.png": 514,
	"./TK.png": 515,
	"./TL.png": 516,
	"./TM.png": 517,
	"./TN.png": 518,
	"./TO.png": 519,
	"./TR.png": 520,
	"./TT.png": 521,
	"./TV.png": 522,
	"./TW.png": 523,
	"./TZ.png": 524,
	"./UA.png": 525,
	"./UG.png": 526,
	"./UM.png": 527,
	"./US.png": 528,
	"./UY.png": 529,
	"./UZ.png": 530,
	"./VA.png": 531,
	"./VC.png": 532,
	"./VE.png": 533,
	"./VG.png": 534,
	"./VI.png": 535,
	"./VN.png": 536,
	"./VU.png": 537,
	"./WF.png": 538,
	"./WS.png": 539,
	"./XK.png": 540,
	"./YE.png": 541,
	"./YT.png": 542,
	"./ZA.png": 543,
	"./ZM.png": 544,
	"./ZW.png": 545,
	"./catalonia.png": 546,
	"./england.png": 547,
	"./europeanunion.png": 548,
	"./fam.png": 549,
	"./scotland.png": 550,
	"./wales.png": 551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;